function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M-105.125,194.563v-86.25h-86.25V-9.063c0-29.052,23.636-52.688,52.688-52.688h33.562v-107.813h234.75V-61.75h33.563 c29.052,0,52.688,23.636,52.688,52.688v117.375h-86.25v86.25H-105.125z M-86,175.438h196.5V65.188H-86V175.438z M129.625,89.188 h67.125v-98.25c0-18.506-15.056-33.563-33.563-33.563h-301.875c-18.507,0-33.563,15.056-33.563,33.563v98.25h67.125V46.063h234.75 V89.188z M-86-61.75h196.5v-88.688H-86V-61.75z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M141.625,11.281c-5.272,0-9.563-4.29-9.563-9.563s4.29-9.563,9.563-9.563s9.563,4.29,9.563,9.563 S146.897,11.281,141.625,11.281z"
})));

var SvgPrint = function SvgPrint(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "440px",
    height: "407px",
    viewBox: "-210.5 -183.5 440 407",
    enableBackground: "new -210.5 -183.5 440 407",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrint, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/print.242c4360.svg";
export { ForwardRef as ReactComponent };